export class PesquisaProtocolos {
  idProtocolo?: number;
  documentoId: string;
  cnpjFornecedor: string;
  nomeFornecedor: string;
  criacaoInicio?: Date;
  criacaoFim?: Date;
  emissaoInicio?: Date;
  emissaoFim?: Date;
  vencimentoInicio?: Date;
  vencimentoFim?: Date;
  idPedido: string;
  conclusaoInicio: Date;
  conclusaoFim: Date;
  loginUsuarioCriacao: string;
  loginAprovador: string;
  loginResponsavel: string;
  statusProtocolo?: number;
  valor?: number;
  tipoProtocolo: string;
  idTipoDocumento: string;
  tipo: string;
  idFiltro?: number;
}
